module.exports = __webpack_public_path__ + "static/img/12.6e4fe2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/12.jpg
// module id = j0Ng
// module chunks = 0